
import NavDrawer from "./nav-drawer/index.vue";
import NavMenubar from "./nav-menubar/index.vue";

export default {
	name: 'PageHeader',
	components: { NavDrawer, NavMenubar },
	computed: {
		isMobile ()
		{
			return this.$vuetify.breakpoint.smAndDown;
		},
	},
}
